import React, { useState, useEffect } from "react";
import {
  Container,
  ContainerView,
  TitlePage,
} from "../../components/Container";
import { useApp } from "../../contexts";
import { IconOpenEye } from "../../components/Icons/IconOpenEye";
import { IconCloseEye } from "../../components/Icons/IconCloseEye";
import { InputOtp } from "../../components/TwoFA/style";
import { ssoUpdatePassword, ssoVerify2FA, ssoGetUserInfo } from "../../services/app";
import { validatePassword } from "../../utils/helper";
import * as Notification from "../../Notification";
import { encryptClientPassword } from "../../utils/helper";
import { SetPassword } from "../../components/SetPassword";

const ERROR_DEFAULT = {
  password: "",
  new_password: "",
  confirm_password: "",
  otp: "",
  form: "",
};
export const ChangePasswordLegacy = () => {
  const { T, user } = useApp();

  const [formData, $formData] = useState({
    password: "",
    new_password: "",
    confirm_password: "",
    verify_code: "",
  });
  const [showPassword, $showPassword] = useState(false);
  const [showNewPassword, $showNewPassword] = useState(false);
  const [showConfirmPassword, $showConfirmPassword] = useState(false);
  const [userData, $userData] = useState(null);
  const [isSettedPass, $isSettedPass] = useState(true);
  const [is2FaEnable, $is2FaEnable] = useState(false);
  const [verify_code, setVerifyCode] = useState("");
  const [error, $error] = useState(ERROR_DEFAULT);
  const triggerShowPassword = () => {
    $showPassword(!showPassword);
  };
  const triggerShowNewPassword = () => {
    $showNewPassword(!showNewPassword);
  };
  const triggerShowConfirmPassword = () => {
    $showConfirmPassword(!showConfirmPassword);
  };

  const changeInput = (key, val) => {
    $formData((data) => {
      data[key] = val;
      return data;
    });
  };
  const onChangeVerifyCode = (e) => {
    setVerifyCode(e);
  };
  const validateForm = () => {
    const errors = {};
    if (isSettedPass && (!formData.password || !formData.password.trim())) {
      errors["password"] = T("Current password not match");
      return errors;
    }
    if (formData.confirm_password !== formData.new_password) {
      errors["confirm_password"] = T("Confirm new password not match.");
      return errors;
    }

    if (!validatePassword(formData.new_password)) {
      errors["new_password"] = T(
        "The password must contain 6 pure letters or is a combination of letters and numbers"
      );
      return errors;
    }
    if (isSettedPass && formData.password === formData.confirm_password) {
      errors["new_password"] = T(
        "Current password could not be same with new password"
      );
      return errors;
    }
    return true;
  };
  const verify2FA = (cb) => {
    ssoVerify2FA({ code: verify_code })
      .then((res) => {
        if (res?.data?.status === false) {
          cb({ message: res?.data?.message }, null);
        } else {
          cb(null, res);
        }
      })
      .catch((err) => {
        cb(err, null);
      });
  };
  const loadProfile = () => {
    ssoGetUserInfo().then(res => {
        const data = res.data?.data || {}
        $userData(data);
        if (!data.has_password) {
          $isSettedPass(false)
        }else{
          $isSettedPass(true);
        }
      })
  }
  useEffect(() => {
    loadProfile()
  },[])
  const changePassword = (e) => {
    ssoUpdatePassword({
      old_password: isSettedPass ? encryptClientPassword(formData.password) : undefined,
      new_password: encryptClientPassword(formData.new_password),
    })
      .then((res) => {
        if (res?.data?.status) {
          $formData({
            password: "",
            new_password: "",
            confirm_password: "",
            verify_code: "",
          });
          e.target.reset();
          if (
            null !== verify_code &&
            undefined !== verify_code &&
            verify_code !== ""
          ) {
            setVerifyCode(null);
          }
          if (!isSettedPass) {
            $isSettedPass(true)
          }
          Notification.success(T("Change password success."));
          
        } else {
          if (res?.data?.code === 102) {
            $error({
              ...ERROR_DEFAULT,
              password: T("The current password is incorrect."),
            });
            // Notification.error(i18n.t("currentPasswordInvalid"))
          } else if (res?.data?.code === 103) {
            $error({
              ...ERROR_DEFAULT,
              form: T("Current password could not be same with new password"),
            });
            // Notification.error(i18n.t("validate_reset_password"))
          } else if (res?.data?.code === 104) {
            $error({ ...ERROR_DEFAULT, otp: T("2FA Code invalid") });
            // Notification.error(i18n.t("code2FAInvalid"))
          } else if (res?.data?.code === 5000) {
            $error({ ...ERROR_DEFAULT, otp: T("2FA Code invalid") });
          } else {
            $error({ ...ERROR_DEFAULT, form: T("Change password fail.") });
            // Notification.error(i18n.t("changePasswordFail"))
          }
        }
      })
      .catch((err) => {
        console.log("AccountService.changePassword=>ERROR", err);
        Notification.error(T("Change password fail."));
      });
  };
  const submitFormChangePassword = (e) => {
    e.preventDefault();
    const resValid = validateForm();
    if (resValid !== true) {
      $error({ ...ERROR_DEFAULT, ...resValid });
      return;
    }
    $error(ERROR_DEFAULT);

    if (is2FaEnable) {
      verify2FA((err, res) => {
        if (err) {
          $error({
            ...ERROR_DEFAULT,
            verify_code: err.message ? T(err.message) : T("2FA Code invalid"),
          });
        } else {
          changePassword(e);
        }
      });
    } else {
      changePassword(e);
    }
  };
  useEffect(() => {
    const is2Fa = user?.is_twofa ? true : false;
    if (!is2Fa) {
      setVerifyCode(null)
    }
    $is2FaEnable(is2Fa);
  }, [user?.is_twofa]);

  return (
    <>
      {userData && !userData.has_password && (
        <SetPassword userData={userData} reloadData={loadProfile}/>
      )}
      {userData && userData.has_password && (
        <Container>
          <ContainerView background="transparent">
            <TitlePage>{T("Password")}</TitlePage>
            <div className="flex justify-between items-start w-full  container mt-[32px] lg:gap-12">
              <div className="w-full block grow-1">
                <form
                  className="w-full"
                  onSubmit={submitFormChangePassword}
                  id="form_change_password"
                >
                  {isSettedPass && (
                    <div className="mb-6 lg:mb-[25px]">
                      <label
                        htmlFor="form_password"
                        className="block text-suzu-gray-9 w-full mb-1 text-[15px] lg:text-base"
                      >
                        {T("Current Password")}
                      </label>
                      <div className="w-full lg:w-[650px] p-[1px] rounded-[10px] relative">
                        <input
                          id="form_password"
                          type={showPassword ? "text" : "password"}
                          minLength={6}
                          maxLength={6}
                          className="h-[52px] w-full lg:max-w-full lg:w-[650px] px-5 py-3 bg-white rounded-[10px] text-black input-gradient"
                          placeholder={T("Enter current password")}
                          defaultValue={formData?.password || ""}
                          onChange={(e) =>
                            changeInput("password", e.target.value)
                          }
                        />
                        <div className="bg-mark"></div>
                        <div
                          className={`w-6 h-6 flex justify-center ${
                            showPassword ? "items-center" : "items-end"
                          } absolute right-4 top-3.5 z-10 cursor-pointer`}
                          onClick={() => triggerShowPassword()}
                        >
                          {showPassword && <IconOpenEye />}
                          {!showPassword && <IconCloseEye />}
                        </div>
                      </div>
                      {error.password && (
                        <p className="z-10 text-suzu-error text-sm">
                          {error.password}
                        </p>
                      )}
                    </div>
                  )}
                  <div className="mb-6 lg:mb-[25px]">
                    <label
                      htmlFor="form_new_password"
                      className="block text-suzu-gray-9 w-full mb-1 text-[15px] lg:text-base"
                    >
                      {T("New Password")}
                    </label>
                    <div className="w-full lg:w-[650px] p-[1px] rounded-[10px] relative">
                      <input
                        id="form_new_password"
                        type={showNewPassword ? "text" : "password"}
                        minLength={6}
                        maxLength={6}
                        className="h-[52px] w-full lg:max-w-full lg:w-[650px] px-5 py-3 bg-white rounded-[10px] text-black input-gradient"
                        placeholder={T("Enter new password")}
                        defaultValue={formData?.new_password || ""}
                        onChange={(e) =>
                          changeInput("new_password", e.target.value)
                        }
                      />
                      <div className="bg-mark"></div>
                      <div
                        className={`w-6 h-6 flex justify-center ${
                          showNewPassword ? "items-center" : "items-end"
                        } absolute right-4 top-3.5 z-10 cursor-pointer`}
                        onClick={() => triggerShowNewPassword()}
                      >
                        {showNewPassword && <IconOpenEye />}
                        {!showNewPassword && <IconCloseEye />}
                      </div>
                    </div>
                    {error.new_password && (
                      <p className=" z-10 text-suzu-error text-sm">
                        {error.new_password}
                      </p>
                    )}
                  </div>
                  <div className="mb-6 lg:mb-[25px]">
                    <label
                      htmlFor="form_confirm_password"
                      className="block text-suzu-gray-9 w-full mb-1 text-[15px] lg:text-base"
                    >
                      {T("Confirm New Password")}
                    </label>
                    <div className="w-full lg:w-[650px] p-[1px] rounded-[10px] relative">
                      <input
                        id="form_confirm_password"
                        type={showConfirmPassword ? "text" : "password"}
                        minLength={6}
                        maxLength={6}
                        className="h-[52px] w-full lg:max-w-full lg:w-[650px] px-5 py-3 bg-white rounded-[10px] text-black input-gradient"
                        placeholder={T("Enter new password again")}
                        defaultValue={formData?.confirm_password || ""}
                        onChange={(e) =>
                          changeInput("confirm_password", e.target.value)
                        }
                      />
                      <div className="bg-mark"></div>
                      <div
                        className={`w-6 h-6 flex justify-center ${
                          showConfirmPassword ? "items-center" : "items-end"
                        } absolute right-4 top-3.5 z-10 cursor-pointer`}
                        onClick={() => triggerShowConfirmPassword()}
                      >
                        {showConfirmPassword && <IconOpenEye />}
                        {!showConfirmPassword && <IconCloseEye />}
                      </div>
                    </div>
                    {error.confirm_password && (
                      <p className=" z-10 text-suzu-error text-sm">
                        {error.confirm_password}
                      </p>
                    )}
                  </div>
                  {is2FaEnable && (
                    <div className="mb-6 lg:mb-[25px]">
                      <label className="block text-suzu-gray-9 w-full mb-1 text-[15px] lg:text-base">
                        {T("2 Factor Authentication")}
                      </label>
                      <div className="w-full relative input-otp">
                        <InputOtp
                          value={verify_code}
                          onChange={(event) => {
                            onChangeVerifyCode(event);
                          }}
                        />
                        {/* <InputOtp
                      ref={inputRef}
                      value={formData.verify_code}
                      onChange={(event) => {
                        onChangeVerifyCode(event);
                      }}
                    /> */}
                        {error.verify_code && (
                          <p className="mt-[12px] text-suzu-error text-sm">
                            {error.verify_code}
                          </p>
                        )}
                      </div>
                    </div>
                  )}
                  <div className="pt-7 pb-[100px]">
                    {error.form && (
                      <p className="mb-2 text-suzu-error text-sm">
                        {error.form}
                      </p>
                    )}
                    <button
                      className="bg-black w-[344px] max-w-full block mx-auto lg:mx-0 lg:w-[190px] h-[52px] text-center text-white rounded-[15px]"
                      type="submit"
                    >
                      {T("Save")}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </ContainerView>
        </Container>
      )}
    </>
  );
};
